import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { clearCases, fetchCases, fetchChildParties, changeCaseSearch, resetCaseSearch  } from '../../store/case';
import { Checkbox } from '@mui/material';
import { CaseSearch } from '../../store/case/model';
import { Dispatch } from 'redux';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import { TypeCodeTranslation } from '../../business/models/shared.model';
import { Role } from '../../store/shared/model';
import styles from './../custom/case-search-bar.module.css';
import FormControl from '@mui/material/FormControl';

interface PropsFromState {
  readonly caseSearch: CaseSearch;
  readonly taskTypeList: TypeCodeTranslation[];
  readonly currentLanguage: string;
  readonly roles: string[];
}

interface PropsFromDispatch {
  readonly fetchCases: typeof fetchCases;
  readonly clearCases: typeof clearCases;
  readonly getChildParties: typeof fetchChildParties;
  readonly changeCaseSearch: typeof changeCaseSearch;
  readonly resetCaseSearch: typeof resetCaseSearch;
}

interface State {
  readonly caseSearch: CaseSearch;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class CaseSearchBar extends React.Component<AllProps, State> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }


  componentWillReceiveProps(nextProps: AllProps) {
  }

  renderTaskTypeDropDown = () => {
    if (this.props.roles.includes(Role.InFiLoAd)) { return; }

    return (
      <FormControl sx={{ padding: '0px' }} size="small">
        <select 
          className={styles.input}
          value={this.props.caseSearch.taskType}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            const searchCase = { ...this.props.caseSearch, taskType: event.target.value };
            this.props.changeCaseSearch(searchCase);
          }}
        >
          <option value=''>{this.localization.get('home.search.taskType')}</option>
          {this.props.taskTypeList.filter(x => x.language === this.props.currentLanguage).map(o => <option value={o.typeCodeValue} key={o.typeCodeValue}>{o.translation}</option>)}
        </select>
      </FormControl>
    );
  }

  renderCaseSearchByParties = () => {
    if (this.props.roles.includes(Role.CoCaIn) || this.props.roles.includes(Role.CoCaEx)) {
      return (
        <FormControl sx={{ padding: '0px' }} size="small">
          <select
              className={styles.input}
              value={this.props.caseSearch.selectedPartyId > 0 ? this.props.caseSearch.selectedPartyId.toString() : ''}
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                const searchCase = { ...this.props.caseSearch, selectedPartyId: +event.target.value, selectedChildPartyId: 0 };
                this.props.changeCaseSearch(searchCase);
                this.props.getChildParties(+event.target.value);
              }}
            >
              <option value=''>{this.localization.get('home.search.chooseCompany')}</option>
              {this.props.caseSearch.parties.map(x => <option value={x.id} key={x.id}>{x.partyName}</option>)}
          </select>
        </FormControl>);
    }
    return;
  }

  renderCaseSearchByChildParty = () => {
    if (this.props.roles.includes(Role.CoCaIn) || this.props.roles.includes(Role.CoCaEx)) {
      return (
        <FormControl sx={{ padding: '0px' }} size="small">
          <select
              className={styles.input}
              value={this.props.caseSearch.selectedChildPartyId > 0 ? this.props.caseSearch.selectedChildPartyId.toString() : ''}
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                const searchCase = { ...this.props.caseSearch, selectedChildPartyId: +event.target.value };
                Promise.resolve(this.props.changeCaseSearch(searchCase))
                        .then(this.searchCases);
              }}
            >
              <option value=''>{this.localization.get('home.search.chooseExpert')}</option>
              {this.props.caseSearch.childParties.map(x => <option value={x.id} key={x.id}>{x.firstName} {x.lastName}</option>)}
          </select>
      </FormControl>
      );
    }
    return;

  }

  renderCaseSearchByAssignParty = () => {
    if (this.props.roles.includes(Role.AsUs)) {
      return (
        <FormControl sx={{ padding: '0px' }} size="small">
          <select
            className={styles.input}
            value={this.props.caseSearch.assignedToPartyId !== undefined ? this.props.caseSearch.assignedToPartyId > 0 ? this.props.caseSearch.assignedToPartyId.toString() : '' : ''}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
              const searchCase = { ...this.props.caseSearch, assignedToPartyId: +event.target.value, selectedChildPartyId: 0 };
              Promise.resolve(this.props.changeCaseSearch(searchCase))
                      .then(this.searchCases);
            }}
          >
            <option value=''>{this.localization.get('home.search.chooseExpert')}</option>
            {this.props.caseSearch.assignedParties.map(x => <option value={x.id} key={x.id}>{x.firstName} {x.lastName}</option>)}
          </select>
        </FormControl>
      );
    }
    return;
  }

  renderInProgressCheckBox = () => {
    return (
      <div className={styles.inputcheckbox}>
      <Checkbox
        checked={this.props.caseSearch.inProgressOnly}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const searchCase = { ...this.props.caseSearch, inProgressOnly: event.target.checked };
          this.props.changeCaseSearch(searchCase);
       }}
        value='true' />
        <span>
      {this.localization.get('home.search.inProgressOnly')}
      </span>
      </div>
      );
  }

  searchCases = () => {
    this.props.clearCases();
    this.props.fetchCases(this.props.caseSearch, 0, true);
  }

  resetSearchCases = () => {
    this.props.resetCaseSearch(this.props.caseSearch);
  }

  renderArchived = () => {
    return (
    <div className={styles.inputcheckbox}>
      <Checkbox
        checked={this.props.caseSearch.archived}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const searchCase = { ...this.props.caseSearch, archived: event.target.checked };
          this.props.changeCaseSearch(searchCase);
       }}
        value='true' />
        <span>
      {this.localization.get('home.search.taskStatus.archived')}
      </span>
      </div>

    );
  }

  render() {
    return (
      <div className={styles.searchContainer}>
        <div className={styles.row}>
          <input autoFocus className={styles.input}
            placeholder={this.localization.get('home.search.caseCode')}
            value={this.props.caseSearch.caseCode}
            onKeyUp={event => {
              if (event.key === 'Enter') {
                this.searchCases();
              }
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const searchCase = { ...this.props.caseSearch, caseCode: event.target.value };
                this.props.changeCaseSearch(searchCase);
            }}
          />
          {this.renderTaskTypeDropDown()}
          <input className={styles.input}
            placeholder={this.localization.get('home.column.agendaRef')}
            value={this.props.caseSearch.agendaRef}
            onKeyUp={event => {
              if (event.key === 'Enter') {
                this.searchCases();
              }
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const searchCase = { ...this.props.caseSearch, agendaRef: event.target.value };
              this.props.changeCaseSearch(searchCase);
            }}
             />
          <input className={styles.input}
            placeholder={this.localization.get('home.search.policyHolder')}
            value={this.props.caseSearch.policyHolder}
            onKeyUp={event => {
              if (event.key === 'Enter') {
                this.searchCases();
              }
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const searchCase = { ...this.props.caseSearch, policyHolder: event.target.value };
              this.props.changeCaseSearch(searchCase);
            }} />
          {this.renderCaseSearchByAssignParty()}
          {this.renderCaseSearchByParties()}
          {this.renderCaseSearchByChildParty()}
          {this.renderInProgressCheckBox()}
          {this.renderArchived()}
          <FormControl sx={{ padding: '0px' }} size="small">
            <button className={styles.button} onClick={() => this.searchCases()}>
              {this.localization.get('home.search.button')}
            </button>
          </FormControl>
          <div className={styles.button} onClick={() => this.resetSearchCases()}>
            <img alt="" className={styles.buttonIcon} src={require('../../assets/images/web_refusal_black_75x75.png')} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ caseState, shared }: ApplicationState): PropsFromState => ({
  caseSearch: caseState.caseSearch,
  taskTypeList: caseState.caseTypeCodes.taskTypeList,
  currentLanguage: shared.currentLanguage,
  roles: shared.roles
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  fetchCases: (caseSearch: CaseSearch, offset: number, searchClicked: boolean) => dispatch(fetchCases(caseSearch, offset, searchClicked)),
  clearCases: () => dispatch(clearCases()),
  getChildParties: (partyId: number) => dispatch(fetchChildParties(partyId)),
  changeCaseSearch: (caseSearch: CaseSearch) => dispatch(changeCaseSearch(caseSearch)),
  resetCaseSearch: (caseSearch: CaseSearch) => dispatch(resetCaseSearch(caseSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseSearchBar);
